import React from "react";
import "../css/Trainers.css";

const Trainers = () => {
  return (
    <div className="trainers7">

      {/* ================= HERO ================= */}
      <section className="t7-hero">
        <h1>The Coaches</h1>
        <p>Experience. Precision. Relentless standards.</p>
      </section>


      {/* ================= TRAINER GRID ================= */}
      <section className="t7-grid">

        <div className="t7-card">
          <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" alt="trainer" />
          <div className="t7-info">
            <h3>Alex Morgan</h3>
            <span>Strength & Power</span>
            <p>Barbell mechanics, raw strength, and disciplined progression.</p>
          </div>
        </div>

        <div className="t7-card">
          <img src="https://images.pexels.com/photos/6455791/pexels-photo-6455791.jpeg" alt="trainer" />
          <div className="t7-info">
            <h3>Jordan Lee</h3>
            <span>Conditioning</span>
            <p>High-output training built for endurance and grit.</p>
          </div>
        </div>

        <div className="t7-card">
          <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="trainer" />
          <div className="t7-info">
            <h3>Chris Nolan</h3>
            <span>Movement</span>
            <p>Joint health, mechanics, and longevity-focused performance.</p>
          </div>
        </div>

        <div className="t7-card">
          <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="trainer" />
          <div className="t7-info">
            <h3>Taylor Reed</h3>
            <span>Athletic Development</span>
            <p>Speed, coordination, and explosive control.</p>
          </div>
        </div>

      </section>


      {/* ================= PHILOSOPHY STRIP ================= */}
      <section className="t7-philosophy">
        <h2>No Shortcuts. No Noise.</h2>
        <p>
          Our coaches don’t chase trends — they build strong bodies
          through proven systems and accountability.
        </p>
      </section>

    </div>
  );
};

export default Trainers;
